module.exports = __webpack_public_path__ + "img/art3_footer.819e5681.png";